// extracted by mini-css-extract-plugin
export default {"pageWrapper":"systemSettings_pageWrapper__el6q7","blockWrapper":"systemSettings_blockWrapper__eRahn","title":"systemSettings_title__f5+CN"};